import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import projects from './utils/Data/ProjectsData';
import ProjectModal from './ProjectModal';
import { useModal } from './ModalContext';

const Projects = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const { isModalOpen, setIsModalOpen } = useModal();

  useEffect(() => {
    const handleScroll = () => {
      if (isModalOpen) return;

      const projectsSection = document.getElementById('projects');
      const windowHeight = window.innerHeight;
      const triggerPosition = windowHeight * 0.8;

      setIsVisible(
        projectsSection.offsetTop < window.scrollY + triggerPosition
      );
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isModalOpen]);

  const handleOpenModal = (project) => {
    setSelectedProject(project);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setSelectedProject(null);
    setIsModalOpen(false);
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
  };

  return (
    <section
      id="projects"
      className={`projects ${isVisible ? 'slideup-anim' : ''}`}
    >
      <h2 className="title">Projets</h2>
      <Slider {...settings}>
        {projects.map((project) => (
          <div
            key={project.id}
            className="project-card"
            onClick={() => handleOpenModal(project)}
          >
            <div className="project-image">
                <img src={project.imageUrl} alt={project.title} />
              
            </div>
          </div>
        ))}
      </Slider>
      {selectedProject && (
        <>
          <div className="modal-overlay" onClick={handleCloseModal}></div>
          <ProjectModal project={selectedProject} onClose={handleCloseModal} />
        </>
      )}
    </section>
  );
};

export default Projects;
